let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1zPk8")).then(() => parcelRequire('eHIwa'));